var sync1 = $("#main-carousel");
var sync2 = $("#option-carousel");

$(document).ready(function() {

    let full_owl = $("#full-carousel").owlCarousel({
        items: 1,
        nav: false,
        dots: false,
        slideSpeed: 2000,
        margin: 20,
        onInitialized: updateDots,
        onChanged: updateDots,
        responsive: {
            0: {
                dots: true
            },
            1280: {
                dots: false
            }
        }
    }).on('changed.owl.carousel', function(event) {
        if (event.item.index === 0)
            $('.full-media .float-nav .owl-prev').prop('disabled', true);
        else 
            $('.full-media .float-nav .owl-prev').prop('disabled', false);

        if (event.item.index === event.item.count - event.page.size)
            $('.full-media .float-nav .owl-next').prop('disabled', true);
        else
            $('.full-media .float-nav .owl-next').prop('disabled', false);
    });
    
    $(".full-media .float-nav .owl-prev").on('click', function() {
        full_owl.trigger('prev.owl.carousel');
    });
    $(".full-media .float-nav .owl-next").on('click', function() {
        full_owl.trigger('next.owl.carousel');
    });

    $('#main-carousel .product-image').on('click', function() {
        let index = $(this).data('slide');

        full_owl.trigger('to.owl.carousel', index)
        
        $('.full-media').css('display', 'flex');
    });
    
    $('.full-media .full-close i').on('click', function() {
        $('.full-media').hide();
    });

    function updateDots(event) {
        const maxDots = 5; // Maximum visible dots at a time
        const totalItems = event.item.count; // Total items in the carousel
        const activeIndex = event.item.index; // Active item index
        const dots = $('.owl-dot'); // Select all dot elements
    
        // Hide all dots initially
        dots.hide();
    
        // Calculate which dot set to show
        const start = Math.floor(activeIndex / maxDots) * maxDots;
        const end = Math.min(start + maxDots, totalItems);
    
        // Show the limited dots in sequence
        for (let i = start; i < end; i++) {
            $(dots[i]).show();
        }
    }

    /* --------------------------------------------------------------------------------------- */

    let syncedSecondary = false;

    sync1.owlCarousel({
        items: 1,
        slideSpeed: 2000,
        nav: false,
        autoplay: false,
        dots: false,
        loop: false,
        margin: 15,
        responsiveRefreshRate: 200,
        onInitialized: enableZoom,
        onChanged: enableZoom
    }).on('changed.owl.carousel', syncPosition);

        $("#product-section-1 .float-nav .owl-prev").on('click', function() {
            sync1.trigger('prev.owl.carousel');

        });
        $("#product-section-1 .float-nav .owl-next").on('click', function() {
            sync1.trigger('next.owl.carousel');
        });

        sync2.on('initialized.owl.carousel', function () {
            sync2.find(".owl-item").eq(0).addClass("current");
        })
        .owlCarousel({
            items: 5,
            nav: false,
            dots: false,
            margin: 15,
            smartSpeed: 200,
            slideSpeed: 500,
            slideBy: 5,
            stagePadding: 20,
            responsiveRefreshRate: 100,
            responsive: {
                0: {
                    margin: 10
                },
                768: {
                    margin: 15
                }
            }
            
    }).on('changed.owl.carousel', syncPosition2);

    function syncPosition(el) {
        //if you set loop to false, you have to restore this next line
        var current = el.item.index;
        
        //if you disable loop you have to comment this block
        /* var count = el.item.count-1;
        var current = Math.round(el.item.index - (el.item.count/2) - .5);
        
        if(current < 0) {
            current = count;
        }
        if(current > count) {
            current = 0;
        } */
        
        //end block

        sync2.find(".owl-item")
            .removeClass("current")
            .eq(current)
            .addClass("current");
        var onscreen = sync2.find('.owl-item.active').length - 1;
        var start = sync2.find('.owl-item.active').first().index();
        var end = sync2.find('.owl-item.active').last().index();

        if (current > end) {
            sync2.data('owl.carousel').to(current, 100, true);
        }
        if (current < start) {
            sync2.data('owl.carousel').to(current - onscreen, 100, true);
        }

        if (el.item.index === 0)
            $('#product-section-1 .float-nav .owl-prev').prop('disabled', true);
        else 
            $('#product-section-1 .float-nav .owl-prev').prop('disabled', false);

        if (el.item.index === el.item.count - el.page.size)
            $('#product-section-1 .float-nav .owl-next').prop('disabled', true);
        else
            $('#product-section-1 .float-nav .owl-next').prop('disabled', false);
    }

    function syncPosition2(el) {
        if (syncedSecondary) {
            var number = el.item.index;
            sync1.data('owl.carousel').to(number, 100, true);
        }
    }

    sync2.on("click", ".owl-item", function (e) {
        e.preventDefault();
        var number = $(this).index();
        sync1.data('owl.carousel').to(number, 300, true);
    });

    function enableZoom() {
        setTimeout(() => {
            if (wSize >= 1280) {
                $('.product-image img').each(function() {
                    $(this).magnify().destroy();
                });
          
                $('#main-carousel .active .product-image img').magnify();
            }
        }, 10);
    }
});